import React, { useState } from 'react';

import { Table, Tag } from 'antd';

import Api from '@utils/api';
import usePayment from '@hooks/usePayment';
import { status_financeiro, stringPayment, stringCheck } from '@components/Constants';
import { doMoney, formatDateToView, compareDates, createAlert } from '@utils/functions';
import { TabTitle, TabList } from './style';

const DetailsPagamento = ({ dataInfos }) => {
    const { registerPayment, registerCheck, confirmPayment, changeCheck } = usePayment();

    const [payments, setPayments] = useState(() => {
        if (dataInfos.financeiro.length > 0) {
            return dataInfos.financeiro;
        }

        return [];
    });

    const handlePaymentUpdate = (dataDTO) => {
        const auxData = [...payments];
        const index = auxData.findIndex(item => item.id_payment === dataDTO.id_payment);
        auxData[index] = dataDTO;

        setPayments(auxData);
    };

    const ShowButtonInstallments = () => {
        return dataInfos.forma_pagamento > 0 &&
            (
                (dataInfos.antecipado === 1 && dataInfos.valor_entrada <= 0 && payments.length < 2) ||
                (dataInfos.antecipado === 1 && dataInfos.valor_entrada > 0 && payments.length <= 2) ||
                (dataInfos.valor_entrada > 0 && payments.length < 2) ||
                payments.length < 1
            )
    }

    const generateInstallments = () => {
        Api(`/request/gen-installments/${dataInfos.id_request}`)
            .then(response => setPayments(response))
            .catch(err => createAlert(err.message));
    }

    const columns = [
        {
            title: 'Código',
            render: ({ id_payment }) => `#${(`00000${id_payment}`).substr(-5)}`
        }, {
            title: 'Tipo',
            render: ({ tipo_pagamento }) => stringPayment[tipo_pagamento]
        }, {
            title: 'Valor',
            render: ({ valor }) => doMoney(valor)
        }, {
            title: 'Venc.',
            render: ({ vencimento }) => formatDateToView(vencimento)
        }, {
            title: 'Dt. Pgto',
            render: ({ vencimento, data_pagamento }) => !data_pagamento && !compareDates(vencimento)
                ? (
                    <span style={{ color: 'RED', fontWeight: 'bold' }}>
                        Em atraso
                    </span>
                ) : (
                    !data_pagamento
                        ? 'Em aberto'
                        : formatDateToView(data_pagamento)
                )
        }, {
            title: '',
            align: 'right',
            width: '20%',
            render: data => !data.data_pagamento && (
                <>
                    {!data.numero_boleto && data.checks.length === 0 && (
                        <span
                            onClick={() => registerPayment(data.id_payment, data.id_request, handlePaymentUpdate)}
                            className="btn btn-default btn-icons"
                            title="Registrar boleto"
                        >
                            <i class="fa fa-barcode m-none"></i>
                        </span>
                    )}

                    {!data.numero_boleto && (
                        <span
                            onClick={() => registerCheck(data, handlePaymentUpdate)}
                            className="btn btn-default btn-icons"
                            title="Adicionar cheque"
                        >
                            <i className="icon-plus m-none" />
                        </span>
                    )}

                    {data.checks.length === 0 && (
                        <span
                            onClick={() => confirmPayment(data.id_payment, data.id_request, handlePaymentUpdate)}
                            className="btn btn-default btn-icons"
                            title="Dar baixa"
                        >
                            <i className="icon-check m-none" />
                        </span>
                    )}
                </>
            )
        }
    ]

    // Tabela de cheques
    const tableInternalRender = ({ checks }) => {
        const columns = [
            {
                title: 'Data p/ dep.',
                render: ({ deposit_date, status }) => !compareDates(deposit_date) && !status
                    ? (
                        <span style={{ color: 'RED', fontWeight: 'bold' }}>
                            {formatDateToView(deposit_date)}
                        </span>
                    )
                    : formatDateToView(deposit_date)
            }, {
                title: 'Código',
                render: ({ code_check }) => <span className="maskCheck">{code_check}</span>
            }, {
                title: 'Status',
                render: ({ status }) => stringCheck[status]
            }, {
                title: 'Valor',
                align: 'right',
                render: ({ check_value }) => doMoney(check_value)
            }, {
                title: '',
                align: 'right',
                width: '15%',
                render: ({ id: id_check, id_payment, status }) => !status
                    ? (
                        <span
                            onClick={() => changeCheck(id_payment, id_check, 1, handlePaymentUpdate)}
                            className="btn btn-default btn-icons"
                            title="Depósitado"
                        >
                            <i className="fa fa-check-square-o m-none"></i>
                        </span>
                    ) : status === 1 && (
                        <>
                            <span
                                onClick={() => changeCheck(id_payment, id_check, 3, handlePaymentUpdate)}
                                className="btn btn-default btn-icons"
                                title="Informar retorno/estorno"
                            >
                                <i className="fa fa-window-close-o m-none"></i>
                            </span>
                            <span
                                onClick={() => changeCheck(id_payment, id_check, 2, handlePaymentUpdate)}
                                className="btn btn-default btn-icons"
                                title="Confirmar compensação"
                            >
                                <i className="fa fa-check-square-o m-none"></i>
                            </span>
                        </>
                    )
            }
        ]

        return <Table size="small" columns={columns} dataSource={checks} pagination={false} />;
    }

    return (
        <div id="pagamento" className="tab-pane fade">
            {ShowButtonInstallments() && (
                <button
                    className="btn btn-default float-right"
                    title="Gerar Faturamento"
                    onClick={generateInstallments}
                >
                    <i className="icon-wallet" />
                    Gerar Faturamento
                </button>
            )}

            <span className="d-inline-block span-p">
                <b className="d-block">Status Financeiro:</b>
                <Tag color={status_financeiro[dataInfos.status_financeiro].color}>
                    {status_financeiro[dataInfos.status_financeiro].title}
                </Tag>
            </span>
            <TabList financeiro>
                <li className="bg-clean-blue">
                    <b>Total Pedido</b>
                    {doMoney(dataInfos.valor_total)}
                </li>
                <li className="bg-clean-green">
                    <b>Total Pago</b>
                    {doMoney(dataInfos.valor_pago)}
                </li>
                <li className="bg-clean-default">
                    <b>Total Pendente</b>
                    {doMoney(dataInfos.valor_total - dataInfos.valor_pago)}
                </li>
            </TabList>
            <TabTitle>Pagamentos</TabTitle>
            <Table
                className="table-requests"
                size="small"
                scroll={{ y: 233 }}
                columns={columns}
                dataSource={payments}
                pagination={{ position: 'none' }}
                expandable={{
                    rowExpandable: data => (data.checks.length > 0),
                    expandedRowRender: tableInternalRender
                }}
            />
        </div>
    )
}

export default DetailsPagamento;
